import { FieldValues, Control, Path } from 'react-hook-form';
import * as React from 'react';

import { FormControl, FormMessage, FormField, FormItem } from '../form';
import { Textarea } from '../textarea/textarea';
import { cn } from '../../utils';

interface FormTextareaProps<T extends FieldValues = FieldValues> {
  componentProps?: Partial<React.ComponentProps<typeof Textarea>>;
  hideErrorMessage?: boolean;
  formControl: Control<T>;
  placeholder: string;
  disabled?: boolean;
  className?: string;
  floating?: boolean;
  required?: boolean;
  name: Path<T>;
}

export function FormTextarea<T extends FieldValues>({
  hideErrorMessage,
  componentProps,
  placeholder,
  formControl,
  className,
  required,
  floating,
  disabled,
  name,
}: FormTextareaProps<T>) {
  return (
    <FormField
      render={({ field, formState }) => {
        const hasError = !!formState.errors[field.name];

        return (
          <FormItem className={cn('relative z-0', className)}>
            <FormControl>
              <Textarea
                {...componentProps}
                {...field}
                placeholder={placeholder}
                disabled={disabled}
                hasError={hasError}
                floating={floating}
                required={required}
                id={field.name}
              />
            </FormControl>
            {!hideErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
      control={formControl}
      name={name}
    />
  );
}
